// extracted by mini-css-extract-plugin
export default {"container":"style_container__HqFnj","privacy":"style_privacy__Crq-a"};